import { inject, INJECTOR, runInInjectionContext } from "@angular/core";
import { CanActivateFn, GuardResult } from "@angular/router";
import { from, isObservable, of, switchMap } from "rxjs";

export const combineAsyncActivateGuards = (...guards: CanActivateFn[]): CanActivateFn => (route, state) => {
	const injector = inject(INJECTOR);

	const runGuard = (guard: CanActivateFn) =>
		runInInjectionContext(injector, () => {
			const result = guard(route, state);
			return isObservable(result) ? result : from(Promise.resolve(result));
		});

	const [first, ...rest] = guards;

	return runGuard(first).pipe(
		switchMap((result: GuardResult) => {
			if (result !== true) return of(result);
			if (rest.length === 0) return of(true);
			return runGuard(combineAsyncActivateGuards(...rest));
		})
	);
};